import { render, staticRenderFns } from "./CardColorGradient.vue?vue&type=template&id=3c80cb57&scoped=true"
import script from "./CardColorGradient.vue?vue&type=script&lang=js"
export * from "./CardColorGradient.vue?vue&type=script&lang=js"
import style0 from "./CardColorGradient.vue?vue&type=style&index=0&id=3c80cb57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c80cb57",
  null
  
)

export default component.exports